
//let currentIndex = 0;

document.querySelectorAll(".prev").forEach(function(prevButton) {
	prevButton.addEventListener("click", function() {
		const parent = this.closest(".product_gallery");
		const slides = parent.querySelectorAll(".slides");
		updateSlider(slides[0], -1 );
	});
});
document.querySelectorAll(".next").forEach(function(nextButton) {
    nextButton.addEventListener("click", function() {

		const parent = this.closest(".product_gallery");
		const slides = parent.querySelectorAll(".slides");
		updateSlider(slides[0], 1 );
	});
});


function updateSlider(slides, direction ) {


	const slides_slides = slides.querySelectorAll(".slide");
	const visibleSlideIndex = getVisibleSlideIndex(slides_slides);
	const totalSlides = slides_slides.length;


	let real_index = (( visibleSlideIndex + direction % totalSlides) + totalSlides) % totalSlides;
	slides_slides.forEach((slide, i) => {
		if (i === real_index) {
			slide.classList.remove("hidden");
		} else {
			slide.classList.add("hidden");
		}
	});
}

function getVisibleSlideIndex(slides) {
	for (let i = 0; i < slides.length; i++) {
		if (!slides[i].classList.contains("hidden")) {
			return i;
		}
	}
	return -1; // Return -1 if no visible slide is found
}

